import { toast } from "react-toastify";

export interface IthemeProviderProps {
  children: React.ReactNode;
}

export function formatarCpfCnpj(valor: string): string {
  const numeros = valor.replace(/\D/g, "");

  if (numeros.length <= 11) {
    // CPF: 000.000.000-00
    return numeros
      .replace(/^(\d{3})(\d)/, "$1.$2")
      .replace(/^(\d{3})\.(\d{3})(\d)/, "$1.$2.$3")
      .replace(/^(\d{3})\.(\d{3})\.(\d{3})(\d{1,2})?$/, "$1.$2.$3-$4");
  } else {
    // CNPJ: 00.000.000/0000-00
    return numeros
      .replace(/^(\d{2})(\d)/, "$1.$2")
      .replace(/^(\d{2})\.(\d{3})(\d)/, "$1.$2.$3")
      .replace(/^(\d{2})\.(\d{3})\.(\d{3})(\d)/, "$1.$2.$3/$4")
      .replace(/^(\d{2})\.(\d{3})\.(\d{3})\/(\d{4})(\d{1,2})?$/, "$1.$2.$3/$4-$5");
  }
}

// Máscara de telefone brasileiro (formato: (99) 99999-9999 ou (99) 9999-9999)
export function formatarTelefone(valor: string): string {
  const numeros = valor.replace(/\D/g, "");
  if (numeros.length <= 10) {
    // Formato fixo: (99) 9999-9999
    return numeros
      .replace(/(\d{2})(\d)/, "($1) $2")
      .replace(/(\d{4})(\d)/, "$1-$2")
      .replace(/(-\d{5})\d+?$/, "$1");
  } else {
    // Formato celular: (99) 99999-9999
    return numeros
      .replace(/(\d{2})(\d)/, "($1) $2")
      .replace(/(\d{5})(\d)/, "$1-$2")
      .replace(/(-\d{4})\d+?$/, "$1");
  }
}


export function toSlug(text: string): string {
  return text
    .normalize("NFD") // separa acentos das letras
    .replace(/[\u0300-\u036f]/g, "") // remove acentos
    .replace(/[^a-zA-Z0-9\s-]/g, "") // remove caracteres especiais
    .trim()
    .replace(/\s+/g, "-") // troca espaços por hífen
    .toLowerCase();
}

export const formatDate = (dateStr: string) =>
  dateStr ? dateStr.substring(0, 10) : "";


export const formatDateBR = (dateString: string) => {
  if (!dateString) return "";
  const [date] = dateString.split(" ");
  const [year, month, day] = date.split("-");
  return `${day}/${month}/${year}`;
};




